<template>
  <div>
    <h5 class="pb-2 w-100 mt-1 font-weight-bold">Pläne</h5>
    <div class="cpics border-top container horizontal-scrollable p-0">
      <div class="form-row ml-0 mr-0 mt-2">
        <div class="col-md-12 col-lg-12 col-xl-9 pb-2 pr-2 pl-0" v-for="plan in task.pdflawflags" :key="plan.pdflawflagid">
          <div class="mapthumb mb-0 w-100 card canvas_div canvas-box border shadow-none">
            <canvas :ref="`taskCanvas${plan.pdflawflagid}`" :id="`canvass${plan.pdflawflagid}`"></canvas>
            <!--          <span>EG EG PL-EG50D</span>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {fabric} from 'fabric'
export default {
  props: ['task'],
  data() {
    return{
      canvas: null,
      images: [],
      h_dif: 0.0,
      zoomImg: '',
      w_dif: 0.0
    }
  },
  mounted () {
    this.task.pdflawflags.forEach( item=> {
      this.getPlanImage(item)
    })
  },

  methods: {
    async getPlanImage (refPoint) {
      this.isBtnNewShow = true
      this.$store.commit('loading', true)
      let _this = this
      if (!refPoint.src){
        await fetch(`${process.env.VUE_APP_GET_METHOD_URL}img&id=${refPoint.pdplanid}&isplan=1&type=l&token=${localStorage.sessiontoken}`, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: 'string'
          }
        }).then(response => response.blob())
          .then(response => {
            let reader = new FileReader()
            reader.readAsDataURL(response)
            reader.onload = function () {
               refPoint.src = reader.result
              _this.setImageInCanvas(refPoint);
            }
          });
      } else {
        _this.setImageInCanvas(refPoint)
      }
    },

    setImageInCanvas(refPoint){
      const canvas = this.createCanvas(refPoint);
      this.setPlanPhotoInCanvas(canvas , refPoint)
      this.isPlan = true
      this.isPoint = true
      this.$store.commit('loading', false)
    },

    createCanvas (refPoint) {
      const ref = document.getElementById(`canvass${refPoint.pdflawflagid}`)
      return new fabric.Canvas(ref, {
        selection: false,
        controlsAboveOverlay: true,
        centeredScaling: true,
        allowTouchScrolling: true,
        hasBorders: false,
        lockRotation: false,
        lockMovement: false,
        lockMovementY: false,
        lockMovementX: false,
        lockUniScaling: false,
        lockScalingY: false,
        lockScalingX: false,
        originX: 'middle',
        originY: 'middle',
        preserveObjectStacking: false,
        pointDragTrue: false,
      })
    },

    async setPlanPhotoInCanvas (canvas, refPoint) {
      let _this = this
      await fabric.Image.fromURL(refPoint.src, function (img) {
        let hgt = document.querySelector('.canvas-box').offsetHeight;
        let canvas_width = document.querySelector('.canvas-box').offsetWidth

        const hPer = (hgt / img.height) * 100
        let width = (img.width / 100) * hPer

        if ( width > canvas_width ) {
          const wdh_difference = width - canvas_width
          const w_dif_per = (wdh_difference / width) * 100
          const cal_hgt = hgt / 100 * w_dif_per
          hgt = hgt - cal_hgt;
          width = canvas_width
        }

        const hPerForOffset = (hgt / img.height) * 100
        const widthForOffset = (img.width / 100) * hPerForOffset
        _this.offset_left = (canvas_width - widthForOffset) / 2

        const image_height = document.querySelector('.canvas-box').offsetHeight;
        const widthForOffsetTop = (width / img.width) * 100
        const heightForOffsetTop = (img.height / 100) * widthForOffsetTop
        _this.offset_top = (image_height - heightForOffsetTop) / 2
        canvas.setHeight(hgt)
        canvas.setWidth(width)

        _this.image = img
        _this.images.height = img.height
        _this.images.width = img.width

        _this.h_dif = (hgt / img.height) * 100
        _this.w_dif = (width / img.width) * 100

        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          backgroundImageStretch: true
        })

        img.set({
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          scaleX: canvas.width / img.width,
          scaleY: canvas.height / img.height
        })
        canvas.renderAll()
        canvas.setWidth(canvas_width)
        const div_height = document.querySelector('.canvas-box').offsetHeight;
        canvas.setHeight(div_height);
        canvas.centerObject(img)
        _this.canvas = canvas
        _this.drawRefPointOnCanvas(refPoint)

        //Add events on canvas
        // _this.addEventsOnCanvas(canvas , refPoint)
      });
    },
    drawRefPointOnCanvas (item) {
      const point = this.createRefPoint();
      const position = this.calculatePositionOnCanvas(item.xcoord, item.ycoord);
      this.canvas.add(point.set({
        left: position.x,
        top: position.y,
        data: item
      }));
      // this.addEventsOnPoint(point);
      // this.setPointsZoom(this.zoomRange, point)
      this.canvas.setActiveObject(point)
      this.canvas.renderAll()
    },
    createRefPoint () {
      return new fabric.Circle({
        fill: 'red',
        hasBorder: false,
        stroke: 'red',
        strokeWidth: 4,
        originX: 'middle',
        originY: 'middle',
        radius: 5,
        hasControls: false,
        selection: false,
        allowTouchScrolling: false,
        hasBorders: false,
        lockMovementX: true,
        lockMovementY: true,
        hoverCursor: 'default',
      })
    },

    calculatePositionOnCanvas (xcoord, ycoord) {
      let img = this.image
      let ow = this.offset_left
      let iw = img.width
      let ih = img.height
      let hdif = this.h_dif
      let wdif = this.w_dif

      let x = (((xcoord + (iw / 2)) / 100) * wdif) + ow
      let y = (((ycoord + (ih / 2)) / 100) * hdif) + this.offset_top
      return {x: x, y: y}
    },
  },

  watch: {
    task: function (val){
      if (this.canvas) {
        this.canvas.clear()
        this.canvas.dispose()
        this.canvas = null
      }
      let _this = this
       val.pdflawflags.forEach( item => {
        _this.getPlanImage(item)
      });
    },
  }
}
</script>
<style scoped>
.visibility-hidden{
  visibility: hidden;
}
.canvas-box{
  height: 15.5rem;
}
.horizontal-scrollable > .form-row {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: thin;
  min-height: 18rem;
}
.horizontal-scrollable > .form-row::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .6);
  background-color: #3399ff9e;
  opacity: 1;
}
.horizontal-scrollable > .form-row::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.6);
  border-radius: 10px;
  background-color: #ffffff;
}
.horizontal-scrollable > .form-row::-webkit-scrollbar {
  width: 6px;
  background-color: #ffffff;
  max-height: 8px;
}
.horizontal-scrollable > .form-row > .col-md-8 {
  display: inline-block;
  float: none;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/preview-tabs/PlanTab.vue